import React from "react"
import "./WebDevelopment.css"
import "./general.css"
//import { online } from "../../dummydata"
//import { FaEdgeLegacy } from "react-icons/fa";

const WebDevelopmentApply = () => {
  return (
    <>
   <div className="section home wf-section webdev">
    <div className="flex-container flex-on-tablet w-container">
      <div className="text-content light narrow">
        
       <h1 className="first-title white">Enrol Now to Ignite Your Potential</h1>
       
     <img src={"assets/images/courses/online/Mobile Phone_Isometric.png"} alt=""/>
     </div>

     <div className=" non-hide">
      <div className="container" id="request">
        
        <div className="container-form">
        <div className="form-title">
            <h3>Apply for course</h3>
        </div>

        <form action="" method="post" onsubmit="return validFormEnquiry(this)">
                <input type="hidden" id="token_response" name="token_response"/>
                
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label for="full-name">Full Name</label>
                      <input type="text" className="form-control" id="full-name" name="name" required/>
                    </div>
                    <div className="col-md-6">
                      <label for="email">Email address</label>
                      <input type="email" className="form-control" id="email" name="email" required/>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-12">
                        <label for="phone-number">Phone Number</label><br/>
                        <input type="hidden" name="ccode" id="ccode"/>
					    
                        <input id="phone" name="phone" className="form-control" type="tel" required=""/>
                        <span id="valid-msg" className="hide"></span>
						<span id="error-msg" className="hide"></span>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label for="preferred-location">Preferred Location</label>
                       <select id="formInput63" className="form-control" name="location" required=""> 
                            <option value="" selected>* Select</option>
                            <option value="Tema">Tema</option>
                            <option value="Mataheko">Mataheko</option>
                                 
                        </select>  
                    </div>
                    <div className="col-md-6">
                      <label for="education-qualification">Educational Qualification</label>
                      <select id="formInput63" className="form-control" name="education_qualification" required=""> 
                            <option value="" selected="">* Select</option>                                             
                            <option value="Senior Secondary School graduate">Senior Secondary School graduate</option>                                             
                            <option value="Junior School Graduate">Junior School Graduate</option>                                             
                            <option value="University Graduate">University Graduate</option>                                             
                            <option value="Others">Others</option>                                             
                        </select>   
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label for="employed">Are you employed?</label>
                        <select id="formInput63" className="form-control" name="currently" required=""> 
                            <option value="" selected="">* Select</option>                                             
                            <option value="Not employed">Not employed</option>                                             
                            <option value="Self Employed">Self Employed</option>                                             
                            <option value="Working as IT Professional">Working as IT Professional</option>                                             
                            <option value="Working as Non-IT Professional">Working as Non-IT Professional</option>                                             
                            <option value="Others">Others</option>                                             
                        </select>  
                    </div>
                    <div className="col-md-6">
                      <label for="nationality">Nationality</label>
                     <select id="formInput63" className="form-control" name="nationality" required>
                         <option value="">Select</option>
                        <option value='Croatia'>Croatia<br/></option>
                    <option value='Cuba'>Cuba<br/></option>
                    <option value='Cyprus'>Cyprus<br/></option>
                    <option value='Czech Republic'>Czech Republic<br/></option>
                    <option value='Denmark'>Denmark<br/></option>
                    <option value='Djibouti'>Djibouti<br/></option>
                    <option value='Dominica'>Dominica<br/></option>
                    <option value='Dominican Republic'>Dominican Republic<br/></option>
                    <option value='East Timor'>East Timor<br/></option>
                    <option value='Ecuador'>Ecuador<br/></option>
                    <option value='Egypt'>Egypt<br/></option>
                    <option value='El Salvador'>El Salvador<br/></option>
                    <option value='Equatorial Guinea'>Equatorial Guinea<br/></option>
                    <option value='Eritrea'>Eritrea<br/></option>
                    <option value='Estonia'>Estonia<br/></option>
                    <option value='Ethiopia'>Ethiopia<br/></option>
                    <option value='Falkland Islands [Islas Malvinas]'>Falkland Islands [Islas Malvinas]<br/></option>
                    <option value='Faroe Islands'>Faroe Islands<br/></option>
                    <option value='Fiji'>Fiji<br/></option>
                    <option value='Finland'>Finland<br/></option>
                    <option value='France'>France<br/></option>
                    <option value='French Guiana'>French Guiana<br/></option>
                    <option value='French Polynesia'>French Polynesia<br/></option>
                    <option value='French Southern Territories'>French Southern Territories<br/></option>
                    <option value='Gabon'>Gabon<br/></option>
                    <option value='Gambia'>Gambia<br/></option>
                    <option value='Georgia'>Georgia<br/></option>
                    <option value='Germany'>Germany<br/></option>
                    <option value='Ghana'>Ghana<br/></option>
                    <option value='Gibraltar'>Gibraltar<br/></option>
                    <option value='Greece'>Greece<br/></option>
                    <option value='Greenland'>Greenland<br/></option>
                    <option value='Grenada'>Grenada<br/></option>
                    <option value='Guadeloupe'>Guadeloupe<br/></option>
                    <option value='Guam'>Guam<br/></option>
                    <option value='Guatemala'>Guatemala<br/></option>
                    <option value='Guernsey'>Guernsey<br/></option>
                    <option value='Guinea'>Guinea<br/></option>
                    <option value='Guinea-Bissau'>Guinea-Bissau<br/></option>
                    <option value='Guyana'>Guyana<br/></option>
                    <option value='Haiti'>Haiti<br/></option>
                    <option value='Heard Island and McDonald Islands'>Heard Island and McDonald Islands<br/></option>
                    <option value='Honduras'>Honduras<br/></option>
                    <option value='Hong Kong'>Hong Kong<br/></option>
                    <option value='Hungary'>Hungary<br/></option>
                    <option value='Iceland'>Iceland<br/></option>
                    <option value='India'>India<br/></option>
                    <option value='Indonesia'>Indonesia<br/></option>
                    <option value='Iran'>Iran<br/></option>
                    <option value='Iraq'>Iraq<br/></option>
                    <option value='Ireland'>Ireland<br/></option>
                    <option value='Isle of Man'>Isle of Man<br/></option>
                    <option value='Israel'>Israel<br/></option>
                    <option value='Italy'>Italy<br/></option>
                    <option value='Jamaica'>Jamaica<br/></option>
                    <option value='Japan'>Japan<br/></option>
                    <option value='Jersey'>Jersey<br/></option>
                    <option value='Jordan'>Jordan<br/></option>
                    <option value='Kazakhstan'>Kazakhstan<br/></option>
                    <option value='Kenya'>Kenya<br/></option>
                    <option value='Kiribati'>Kiribati<br/></option>
                    <option value='Kosovo'>Kosovo<br/></option>
                    <option value='Kuwait'>Kuwait<br/></option>
                    <option value='Kyrgyzstan'>Kyrgyzstan<br/></option>
                    <option value='Laos'>Laos<br/></option>
                    <option value='Latvia'>Latvia<br/></option>
                    <option value='Lebanon'>Lebanon<br/></option>
                    <option value='Lesotho'>Lesotho<br/></option>
                    <option value='Liberia'>Liberia<br/></option>
                    <option value='Libya'>Libya<br/></option>
                    <option value='Liechtenstein'>Liechtenstein<br/></option>
                    <option value='Lithuania'>Lithuania<br/></option>
                    <option value='Luxembourg'>Luxembourg<br/></option>
                    <option value='Macau'>Macau<br/></option>
                    <option value='Macedonia [FYROM]'>Macedonia [FYROM]<br/></option>
                    <option value='Madagascar'>Madagascar<br/></option>
                    <option value='Malawi'>Malawi<br/></option>
                    <option value='Malaysia'>Malaysia<br/></option>
                    <option value='Maldives'>Maldives<br/></option>
                    <option value='Mali'>Mali<br/></option>
                    <option value='Malta'>Malta<br/></option>
                    <option value='Marshall Islands'>Marshall Islands<br/></option>
                    <option value='Martinique'>Martinique<br/></option>
                    <option value='Mauritania'>Mauritania<br/></option>
                    <option value='Mauritius'>Mauritius<br/></option>
                    <option value='Mayotte'>Mayotte<br/></option>
                    <option value='Mexico'>Mexico<br/></option>
                    <option value='Micronesia'>Micronesia<br/></option>
                    <option value='Moldova'>Moldova<br/></option>
                    <option value='Monaco'>Monaco<br/></option>
                    <option value='Mongolia'>Mongolia<br/></option>
                    <option value='Montenegro'>Montenegro<br/></option>
                    <option value='Montserrat'>Montserrat<br/></option>
                    <option value='Morocco'>Morocco<br/></option>
                    <option value='Mozambique'>Mozambique<br/></option>
                    <option value='Myanmar [Burma]'>Myanmar [Burma]<br/></option>
                    <option value='Namibia'>Namibia<br/></option>
                    <option value='Nauru'>Nauru<br/></option>
                    <option value='Nepal'>Nepal<br/></option>
                    <option value='Netherlands'>Netherlands<br/></option>
                    <option value='New Caledonia'>New Caledonia<br/></option>
                    <option value='New Zealand'>New Zealand<br/></option>
                    <option value='Nicaragua'>Nicaragua<br/></option>
                    <option value='Niger'>Niger<br/></option>
                    <option value='Nigeria'>Nigeria<br/></option>
                    <option value='Niue'>Niue<br/></option>
                    <option value='Norfolk Island'>Norfolk Island<br/></option>
                    <option value='North Korea'>North Korea<br/></option>
                    <option value='Northern Mariana Islands'>Northern Mariana Islands<br/></option>
                    <option value='Norway'>Norway<br/></option>
                    <option value='Oman'>Oman<br/></option>
                    <option value='Pakistan'>Pakistan<br/></option>
                    <option value='Palau'>Palau<br/></option>
                    <option value='Palestine'>Palestine<br/></option>
                    <option value='Panama'>Panama<br/></option>
                    <option value='Papua New Guinea'>Papua New Guinea<br/></option>
                    <option value='Paraguay'>Paraguay<br/></option>
                    <option value='Peru'>Peru<br/></option>
                    <option value='Philippines'>Philippines<br/></option>
                    <option value='Pitcairn Islands'>Pitcairn Islands<br/></option>
                    <option value='Poland'>Poland<br/></option>
                    <option value='Portugal'>Portugal<br/></option>
                    <option value='Puerto Rico'>Puerto Rico<br/></option>
                    <option value='Qatar'>Qatar<br/></option>
                    <option value='Republic of the Congo'>Republic of the Congo<br/></option>
                    <option value='Réunion'>Réunion<br/></option>
                    <option value='Romania'>Romania<br/></option>
                    <option value='Russia'>Russia<br/></option>
                    <option value='Rwanda'>Rwanda<br/></option>
                    <option value='Saint Barthélemy'>Saint Barthélemy<br/></option>
                    <option value='Saint Helena'>Saint Helena<br/></option>
                    <option value='Saint Kitts and Nevis'>Saint Kitts and Nevis<br/></option>
                    <option value='Saint Lucia'>Saint Lucia<br/></option>
                    <option value='Saint Martin'>Saint Martin<br/></option>
                    <option value='Saint Pierre and Miquelon'>Saint Pierre and Miquelon<br/></option>
                    <option value='Saint Vincent and the Grenadines'>Saint Vincent and the Grenadines<br/></option>
                    <option value='Samoa'>Samoa<br/></option>
                    <option value='San Marino'>San Marino<br/></option>
                    <option value='São Tomé and Príncipe'>São Tomé and Príncipe<br/></option>
                    <option value='Saudi Arabia'>Saudi Arabia<br/></option>
                    <option value='Senegal'>Senegal<br/></option>
                    <option value='Serbia'>Serbia<br/></option>
                    <option value='Seychelles'>Seychelles<br/></option>
                    <option value='Sierra Leone'>Sierra Leone<br/></option>
                    <option value='Singapore'>Singapore<br/></option>
                    <option value='Slovakia'>Slovakia<br/></option>
                    <option value='Slovenia'>Slovenia<br/></option>
                    <option value='Solomon Islands'>Solomon Islands<br/></option>
                    <option value='Somalia'>Somalia<br/></option>
                    <option value='South Africa'>South Africa<br/></option>
                    <option value='South Georgia and the South Sandwich Islands'>South Georgia and the South Sandwich Islands<br/></option>
                    <option value='South Korea'>South Korea<br/></option>
                    <option value='South Sudan'>South Sudan<br/></option>
                    <option value='Spain'>Spain<br/></option>
                    <option value='Sri Lanka'>Sri Lanka<br/></option>
                    <option value='Sudan'>Sudan<br/></option>
                    <option value='Suriname'>Suriname<br/></option>
                    <option value='Svalbard and Jan Mayen'>Svalbard and Jan Mayen<br/></option>
                    <option value='Swaziland'>Swaziland<br/></option>
                    <option value='Sweden'>Sweden<br/></option>
                    <option value='Switzerland'>Switzerland<br/></option>
                    <option value='Syria'>Syria<br/></option>
                    <option value='Taiwan'>Taiwan<br/></option>
                    <option value='Tajikistan'>Tajikistan<br/></option>
                    <option value='Tanzania'>Tanzania<br/></option>
                    <option value='Thailand'>Thailand<br/></option>
                    <option value='Togo'>Togo<br/></option>
                    <option value='Tokelau'>Tokelau<br/></option>
                    <option value='Tonga'>Tonga<br/></option>
                    <option value='Trinidad and Tobago'>Trinidad and Tobago<br/></option>
                    <option value='Tunisia'>Tunisia<br/></option>
                    <option value='Turkey'>Turkey<br/></option>
                    <option value='Turkmenistan'>Turkmenistan<br/></option>
                    <option value='Turks and Caicos Islands'>Turks and Caicos Islands<br/></option>
                    <option value='Tuvalu'>Tuvalu<br/></option>
                    <option value='Uganda'>Uganda<br/></option>
                    <option value='Ukraine'>Ukraine<br/></option>
                    <option value='United Arab Emirates'>United Arab Emirates<br/></option>
                    <option value='United Kingdom'>United Kingdom<br/></option>
                    <option value='United States'>United States<br/></option>
                    <option value='Uruguay'>Uruguay<br/></option>
                    <option value='Uzbekistan'>Uzbekistan<br/></option>
                    <option value='Vanuatu'>Vanuatu<br/></option>
                    <option value='Vatican City'>Vatican City<br/></option>
                    <option value='Venezuela'>Venezuela<br/></option>
                    <option value='Vietnam'>Vietnam<br/></option>
                    <option value='Virgin Islands, British'>Virgin Islands, British<br/></option>
                    <option value='Virgin Islands, US'>Virgin Islands, US<br/></option>
                    <option value='Wallis and Futuna'>Wallis and Futuna<br/></option>
                    <option value='Western Sahara'>Western Sahara<br/></option>
                    <option value='Yemen'>Yemen<br/></option>
                    <option value='Zambia'>Zambia<br/></option>
                    <option value='Zimbabwe'>Zimbabwe<br/></option>
                    </select>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-12">
                      <label for="course-interested">Course Interested</label>
                      <select name="category" class="form-control" id="category" required="">                 
                        <option value="">*Choose a course</option>
                        <option value="Network Administration">Network Administration </option>
                        <option value="Software Development">Software Development </option>
                        <option value="Graphic Design">Graphic Design </option>
                        <option value="Microsoft Office">Microsoft Office </option>
                        <option value="Data Analytics">Data Analytics </option>
                        <option value="Social Media Marketing">Social Media Marketing</option>
                        <option value="Digital Marketing">Digital Marketing</option>
                        <option value="Python Programming">Python Programming </option>
                        <option value="Full Stack Development">Full Stack Development </option>
                        <option value="Computer Hardware">Computer Hardware</option>
                        <option value="Cybersecurity">Cybersecurity </option>
                        <option value="Web Development">Web Development</option>
                        <option value="Robotics">Robotics</option>
                        <option value="Kids Coding">Kids Coding</option>
                      </select>
                  </div>
                  </div>
                  <div className="form-group row">
                  <div className="col-md-12">
                    <label for="how-hear-about-us">How did you hear about us?</label>
                    <select id="formInput63" className="form-control" name="how_did_you_hear" required=""> 
                        <option value="">*Select</option>
                        <option value="TV">TV</option>
                        <option value="Radio">Radio</option>
                        <option value="Online Search">Online Search</option>
                        <option value="Billboard">Billboard</option>
                        <option value="School Visit">School Visit</option>
                        <option value="Flyer">Flyer</option>
                        <option value="Newspaper / Print Ad">Newspaper / Print Ad</option>
                        <option value="Friend / Referral">Friend / Referral</option>
                        <option value="Facebook">Facebook</option>
                        <option value="Twitter">Twitter</option>
                        <option value="Instagram">Instagram</option>
                        <option value="Others">Others</option>
					</select>
                  </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-12">
                      <label for="comments">Comments</label>
                      <textarea name="comments" id="comments" className="form-control text-area" rows="1" placeholder="Details Required"></textarea>
                      <input type="hidden" id="id_prog" name="id_prog" value="156"/>
                      <input type="hidden" id="coursetype" name="coursetype" value="Certificate Programs"/>
                      <input type="hidden" name="source" value="certificate-in-fullstack-development.php"/> 
                    </div>
                  </div>
                  
                  <div className="form-group row">
                    <div className="col-md-12 text-center">
                      <br /><br /><button type="submit" className="button big _280 w-button c-buuton">Submit</button>
                    </div>
                  </div>

                </form>

                </div>
        </div>
      </div>
    </div>
  </div>
              
    </>
  )
}

export default WebDevelopmentApply;
